import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import classnames from 'classnames';
import styles from './index.module.scss';

const { confirm, warning } = Modal;

export const Confirm = (param: any) => {
  const { title = null, content = null, ...other } = param;
  confirm({
    className: styles['confirm-modal'],
    ...other,
    title: title,
    content: (
      <div
        className={classnames(styles['content'], {
          [styles['content-none']]: !content
        })}
      >
        {content}
      </div>
    )
  });
};
export const Warning = (param: any) => {
  const { title = null, content = null, ...other } = param;
  warning({
    className: styles['confirm-modal'],
    ...other,
    title: title,
    content: (
      <div
        className={classnames(styles['content'], {
          [styles['content-none']]: !content
        })}
      >
        {content}
      </div>
    )
  });
};
